export default "__VITE_ASSET__fRt69p94__"